import type { SceneObject } from "../../SceneHost";
import { svgGroupTransform } from "../../transform/rotate";
import { framePaint, frameTitle, isFrameObject } from "../../frame/frameContext";

const SVG_NS = "http://www.w3.org/2000/svg";

function applyFramePaint(el: SVGGElement, obj: SceneObject): void {
  const paint = framePaint(obj);
  const rect = el.querySelector(".wb-frame-rect");
  if (rect) {
    rect.setAttribute("fill", paint.fill);
    rect.setAttribute("stroke", paint.stroke);
  }
  const label = el.querySelector(".wb-frame-title");
  if (label) {
    label.setAttribute("fill", paint.title);
    label.textContent = frameTitle(obj);
  }
}

export function renderFrameObject(obj: SceneObject): SVGGElement {
  const w = typeof obj.w === "number" ? obj.w : 640;
  const h = typeof obj.h === "number" ? obj.h : 400;
  const paint = framePaint(obj);
  const title = frameTitle(obj);

  const g = document.createElementNS(SVG_NS, "g");
  g.setAttribute("class", "wb-scene-obj wb-scene-obj--frame");
  g.setAttribute("data-object-id", obj.id);
  g.setAttribute("transform", svgGroupTransform(obj));

  const rect = document.createElementNS(SVG_NS, "rect");
  rect.setAttribute("class", "wb-frame-rect");
  rect.setAttribute("x", "0");
  rect.setAttribute("y", "0");
  rect.setAttribute("width", String(w));
  rect.setAttribute("height", String(h));
  rect.setAttribute("rx", "8");
  rect.setAttribute("ry", "8");
  rect.setAttribute("fill", paint.fill);
  rect.setAttribute("stroke", paint.stroke);
  g.appendChild(rect);

  const label = document.createElementNS(SVG_NS, "text");
  label.setAttribute("class", "wb-frame-title");
  label.setAttribute("x", "10");
  label.setAttribute("y", "-8");
  label.setAttribute("fill", paint.title);
  label.textContent = title;
  g.appendChild(label);

  return g;
}

export function syncFrameOnGroup(el: SVGGElement, obj: SceneObject): void {
  if (!isFrameObject(obj)) return;
  const w = typeof obj.w === "number" ? obj.w : 640;
  const h = typeof obj.h === "number" ? obj.h : 400;
  el.setAttribute("transform", svgGroupTransform(obj));
  const rect = el.querySelector(".wb-frame-rect");
  if (rect) {
    rect.setAttribute("width", String(w));
    rect.setAttribute("height", String(h));
  }
  applyFramePaint(el, obj);
}
